module.exports = __webpack_public_path__ + "img/favicon.8ca14044.png";